import styled from 'styled-components'
import {
  AccordionWrapper,
  AccordionHeader,
  AccordionTitle,
} from '../Accordion/style'
import { CardText } from '../PageFooter/Footer.styled'
import { AccordionContent } from '../CheckBox/style'
import theme from '../../styles/theme'

export const CardContainer = styled(AccordionWrapper)`
  padding: 24px 0px 0px 0px;
`

export const CardHeader = styled(AccordionHeader)``
export const CardTitle = styled(AccordionTitle)``

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${theme.color.white};
  box-shadow: inset 0px -1px 0px ${theme.color.boxShadow};
  padding: 1rem;
`
export const CardContent = styled(CardText)``
export const CardAccordionWrapper = styled.div``

export const CardAccordionContent = styled(AccordionContent)`
  padding: 0px;
  visibility: ${(props) => (props['aria-hidden'] ? 'hidden' : 'visible')};
  & > p {
    padding-top: 0;
    margin-bottom: 10px;
    &:first-child {
      padding-top: 6px;
    }
    &:last-child {
      padding-bottom: 6px;
    }
    & > button {
      background: transparent;
      border: none;
      text-decoration: underline;
      font-size: 1rem;
      line-height: 1.5;
      padding: 0px;
      color: ${theme.color.btnText};
    }
  }
`
